import { type PropsWithChildren } from "react";
import { cn } from "ui";

export interface PageProps extends PropsWithChildren {
  className?: string;
}

export function Page(props: PageProps) {
  return (
    <div className={cn("h-full p-2", props.className ?? "")}>
      {props.children}
    </div>
  );
}
